import type { Distance, SpatialRectangle } from "@pdfking/math"
import { GetXY } from "@pdfking/math"
import { Identity } from "@pdfking/tfunc"

import type { ImpositionNode } from "#internal"

/**
 * Whether any page under `node` touches `rect`, edges included. Every node's
 * box holds its children's, so a branch `rect` misses is never walked.
 *
 * Room kept round the pages goes on `rect`: growing the query by it is growing
 * every page by it. `from_sheet` reads the nodes in the frame `rect` is in, for
 * a drawing on a turned node; a quarter turn or a mirror keeps every box inside
 * its parent's.
 */
export const Intersect = (
  node: ImpositionNode,
  rect: SpatialRectangle<Distance>,
  from_sheet: (box: SpatialRectangle<Distance>) => SpatialRectangle<Distance> = Identity
): boolean => {
  const a = GetXY(from_sheet(node.position))
  const b = GetXY(rect)
  if (a.x1 > b.x2 || b.x1 > a.x2 || a.y1 > b.y2 || b.y1 > a.y2) return false
  return !!node.page || node.children.some(child => Intersect(child, rect, from_sheet))
}
